import {
	getAllPushWebSchedules,
	getAllPushLogs,
	filterPushLogs,
	getServices,
	updateMessages,
	postPushWeb,
	getAllowedsToCancel,
	cancelScheddule,
	getLogsPushWebDetails
} from '@/api/Erp'

export default {
	async allLogs(current_page, page_size, search, token) {
		try {

			const response = await getAllPushLogs.get({
				uriParams: {
					current_page,
					page_size,
					search
				},
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})

			return response.data
		} catch (error) {
			return error.response
		}
	},
	async getAllowedsToCancel(token) {
		try {

			const response = await getAllowedsToCancel.get({
				uriParams: {},
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})

			return response.data
		} catch (error) {
			return error.response
		}
	},
	async allPushWebSchedules(current_page, page_size, search, token) {
		try {
			const response = await getAllPushWebSchedules.get({
				uriParams: {
					current_page,
					page_size,
					search
				},
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})

			return response.data
		} catch (error) {
			return error.response
		}
	},
	async filterLogs(current_page, page_size, email, search_message, token) {
		try {
			const response = await filterPushLogs.get({
				uriParams: {
					current_page,
					page_size,
					email,
					search_message
				},
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})
			return response.data
		} catch (error) {
			return error.response
		}
	},
	async getServices(token) {
		try {
			const response = await getServices.get({
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async updateMessages(payload, token) {
		try {
			const response = await updateMessages.patch(
				{
					channelType: payload.channelType,
					dateAdded: payload.dateAdded,
					list: payload.list,
					message: payload.message,
					messageType: payload.messageType,
					moeCampaignName: payload.moeCampaignName,
					name: payload.name,
					produtoSlug: payload.produtoSlug,
					pushType: payload.pushType,
					sendTime: payload.sendTime,
					smsContent: payload.smsContent,
					title: payload.title,
					url: payload.url
				},
				{
					uriParams: {
						id: payload.name
					},
					headers: {
						'Authorization': `Bearer ${token}`
					}
				}
			)
			return response
		} catch (error) {
			return error.response
		}
	},
	async cancelScheddule(payload, token) {
		try {
			const response = cancelScheddule.post(
				payload,
				{
					headers: {
						'Authorization': `Bearer ${token}`
					}
				}
			)
			return response
		} catch (error) {
			return error.response
		}
	},
	async postPush(payload, token) {
		try {
			const response = postPushWeb.post(
				payload,
				{
					headers: {
						'Authorization': `Bearer ${token}`
					}
				}
			)
			return response
		} catch (error) {
			return error.response
		}
	},
	async getLogsPushDetails(idUser, token) {
    try {
      const response = await getLogsPushWebDetails.get({
        uriParams: {
          idUser
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/push_web_logs/resources.js